import axios from '@/utils/axios';
const testApi = {
  getList: (data?: any) => axios.post('/login/loginByMobile', data), //测试API
};
export default testApi;
